export const convertSapToNewlineLinebreaks = (string: string): string => {
    const convertedContent = string.replace(/(\\n)/g, '\n');

    return convertedContent;
};
